(() => {
  'use strict';
  // Keep only a same-shop collection destination in this tab's session.
  function collectionUrl(value, origin) {
    try {
      const url = new URL(value, origin);
      if (url.origin !== origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/[^/]+(?:\/[^/]+)?\/?$/i.test(url.pathname) || /\/collections\/all\/?$/.test(url.pathname)) return null;
      for (const name of [...url.searchParams.keys()]) {
        if (!['sort_by', 'page', 'oww_page', 'preview_theme_id'].includes(name) && !name.startsWith('filter.')) url.searchParams.delete(name);
      }
      return url.pathname + url.search + url.hash;
    } catch { return null; }
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { collectionUrl };
  if (typeof document === 'undefined') return;
  const config = document.querySelector('script[data-oww-continue-shopping]');
  if (!config) return;
  const key = 'oww-last-collection:' + config.dataset.theme;
  const isCollection = Boolean(config.dataset.collection);
  const returning = new URL(location.href).searchParams.get('oww_return') === '1';
  function read() {
    try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch { return null; }
  }
  function remember() {
    if (!isCollection) return;
    const url = collectionUrl(location.href, location.origin);
    if (!url) return;
    const record = { url };
    // Temporary preview controls are not Shopify URL filters. Preserve their
    // visible selection too; this adapter is removed with the preview fixture.
    const preview = document.querySelector('oww-catalogue-preview');
    if (preview?.initialized) {
      record.preview = {};
      for (const name of ['stock', 'min', 'max', 'size', 'group', 'sort']) {
        const control = preview.querySelector('[data-catalogue-' + name + ']');
        if (control) record.preview[name] = name === 'stock' ? control.checked : control.value;
      }
      record.preview.page = preview.page;
    }
    const wash = document.querySelector('oww-wasgoed-preview');
    const dust = document.querySelector('oww-stof-groups');
    if (wash?.initialized) record.familyControls = { tag: 'oww-wasgoed-preview', family: wash.family, stock: wash.stock.checked, sort: wash.sort.value };
    else if (dust?.initialized) record.familyControls = { tag: 'oww-stof-groups', family: dust.familySelect.value };
    try { sessionStorage.setItem(key, JSON.stringify(record)); } catch { /* Homepage remains usable when storage is blocked. */ }
  }
  function destination() {
    const valid = collectionUrl(read()?.url, location.origin);
    if (!valid) return config.dataset.home || '/';
    const url = new URL(valid, location.origin);
    url.searchParams.set('oww_return', '1');
    return url.pathname + url.search + url.hash;
  }
  function updateLinks() {
    document.querySelectorAll('[data-oww-continue-link]').forEach(link => { link.href = destination(); });
  }
  const saved = returning ? read() : null;
  if (returning) {
    const clean = new URL(location.href); clean.searchParams.delete('oww_return');
    history.replaceState(history.state, '', clean);
  }
  function restorePreview() {
    if (saved?.familyControls) {
      const state = saved.familyControls;
      if (!['oww-wasgoed-preview', 'oww-stof-groups'].includes(state.tag)) return false;
      const family = document.querySelector(state.tag);
      if (!family?.initialized) return false;
      if (state.tag === 'oww-wasgoed-preview') {
        family.family = family.presentFamilies.includes(state.family) ? state.family : '';
        family.stock.checked = Boolean(state.stock); family.sort.value = state.sort;
      } else family.familySelect.value = state.family;
      family.render(); return true;
    }
    const preview = document.querySelector('oww-catalogue-preview');
    if (!preview?.initialized || !saved?.preview) return false;
    if (collectionUrl(saved.url, location.origin)?.split('?')[0].split('#')[0] !== location.pathname) return false;
    for (const name of ['stock', 'min', 'max', 'size', 'group', 'sort']) {
      const control = preview.querySelector('[data-catalogue-' + name + ']');
      if (!control || saved.preview[name] === undefined) continue;
      if (name === 'stock') control.checked = Boolean(saved.preview[name]);
      else control.value = String(saved.preview[name]);
    }
    preview.page = Math.max(1, Number(saved.preview.page) || 1);
    preview.render(); preview.writePage(false);
    return true;
  }
  if ((saved?.preview || saved?.familyControls) && isCollection) {
    if (!restorePreview()) {
      const observer = new MutationObserver(() => {
        const preview = document.querySelector(saved.familyControls?.tag || 'oww-catalogue-preview');
        if (preview?.initialized) { observer.disconnect(); restorePreview(); remember(); }
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
      window.addEventListener('load', () => { observer.disconnect(); restorePreview(); remember(); }, { once: true });
    }
  } else remember();
  updateLinks();
  window.addEventListener('pagehide', remember);
  window.addEventListener('pageshow', () => { remember(); updateLinks(); });
  document.addEventListener('click', event => {
    const link = event.target.closest?.('[data-oww-continue-link]');
    if (link) link.href = destination();
    else if (event.target.closest?.('a[href]')) remember();
  }, true);
})();
